"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signedBalance = signedBalance;
exports.accountStatement = accountStatement;
const money_1 = require("../money");
/** رصيد بإشارة الطبيعة: الحساب الدائن بطبيعته يُقرأ دائنًا ناقص مدين، كما فى الميزان. */
function signedBalance(normalBalance, debit, credit) {
    return normalBalance === 'credit'
        ? money_1.Money.of(credit).sub(debit).normalize()
        : money_1.Money.of(debit).sub(credit).normalize();
}
/**
 * كشف حساب من الحركة المرتّبة: افتتاحى + رصيد جارٍ بعد كل سطر + ختامى.
 *
 * الحركة تصل **مرتّبة** من المتصل — الرصيد الجارى يعتمد على الترتيب، فالدالة
 * لا تعيد ترتيبًا قد يخالف ما يراه المستخدم. والختامى = الافتتاحى + صافى
 * الحركة دائمًا، فلا يمكن أن يختلف الكشف مع نفسه.
 */
function accountStatement(normalBalance, opening, movements) {
    const openingBalance = signedBalance(normalBalance, opening.debit, opening.credit);
    let running = openingBalance;
    let totalDebit = money_1.Money.zero();
    let totalCredit = money_1.Money.zero();
    const lines = movements.map((movement) => {
        const debit = money_1.Money.of(movement.debit).normalize();
        const credit = money_1.Money.of(movement.credit).normalize();
        running = running.add(signedBalance(normalBalance, debit, credit)).normalize();
        totalDebit = totalDebit.add(debit);
        totalCredit = totalCredit.add(credit);
        return { debit, credit, runningBalance: running };
    });
    return {
        openingBalance,
        lines,
        totalDebit: totalDebit.normalize(),
        totalCredit: totalCredit.normalize(),
        closingBalance: running,
    };
}
//# sourceMappingURL=account-statement.js.map